// Chakra imports
import {
  Avatar,
  Box,
  Flex,
  FormLabel,
  Icon,
  SimpleGrid,
  useColorModeValue,
} from "@chakra-ui/react";
// Assets
import Tn from "assets/img/dashboards/tn.png";
// Custom components
import MiniCalendar from "components/calendar/MiniCalendar";
import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import React, { useEffect, useState } from "react";
import { FaUser, FaUserTie } from "react-icons/fa";
import { MdFileCopy } from "react-icons/md";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import ComplexTable from "views/admin/default/components/ComplexTable";
import PieCard from "views/admin/default/components/PieCard";
import TotalSpent from "views/admin/default/components/TotalSpent";
import tableDataComplex1 from "views/admin/default/variables/tableDataComplex1";

import { setFormations } from "redux/slices/formationsSlice";

import { apiurl } from "APIURL";
import axios from "axios";
import { setGlobalCourses } from "redux/slices/coursesSlice";
import { getUserData, setProfile } from "redux/slices/userSlice";

export default function UserReports() {
  // Chakra Color Mode
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const [loadingTable, setLoadingTable] = useState(true);
  const dispatch = useAppDispatch();
  const [loadingFormation, setLoadingFormation] = useState(true);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [count, setCount] = useState(null);
  const [totalProfit, setTotalProfit] = useState(null);
  const [dailyUserCreationData, setDailyUserCreationData] = useState([]);
  const [formateurCount, setFormateurCount] = useState(0);
  const [membrettCount, setMembre] = useState(0);
  useEffect(() => {
    async function fetchMembreTTCount() {
      try {
        const response = await axios.get(`${apiurl}/stats/membrettCount`);
        setMembre(response.data);
      } catch (error) {
        console.error(error);
      }
    }

    fetchMembreTTCount();
  }, []);

  useEffect(() => {
    async function fetchformateurcount() {
      try {
        const response = await axios.get(`${apiurl}/stats/formateurCount`);
        setFormateurCount(response.data);
      } catch (error) {
        console.error(error);
      }
    }

    fetchformateurcount();
  }, []);

  useEffect(() => {
    async function fetchDailyUserCreationData() {
      try {
        const response = await axios.get(
          `${apiurl}/stats/dailyUserCreationData`
        );
        setDailyUserCreationData(response.data);
      } catch (error) {
        console.error(error);
      }
    }

    fetchDailyUserCreationData();
  }, []);

  useEffect(() => {
    async function fetchTotalProfit() {
      try {
        const response = await axios.get(`${apiurl}/stats/profit`);
        const data = response.data;
        setTotalProfit(data);
      } catch (error) {
        console.error(error);
      }
    }

    fetchTotalProfit();
  }, []);

  useEffect(() => {
    async function fetchCount() {
      const response = await axios.get(`${apiurl}/formation`);
      const data = response.data;

      setCount(data.length);
    }

    fetchCount();
  }, []);
  React.useEffect(() => {
    const getFormationData = async () => {
      try {
        const res = await axios.get(`${apiurl}/formation`);
        dispatch(setFormations(res.data));
        setLoadingFormation(false);
      } catch (error) {
        console.log(error);
      }
    };
    getFormationData();
  }, [dispatch]);
  React.useEffect(() => {
    const getCoursesData = async () => {
      try {
        const res = await axios.get(`${apiurl}/course`);
        dispatch(setGlobalCourses(res.data));
        {
          /*console.log({courses})*/
        }
        setLoadingCourses(false);
      } catch (error) {
        console.log(error);
      }
    };
    getCoursesData();
  }, [dispatch]);
  const user = useAppSelector(getUserData);
  const token = localStorage.getItem("token");
  React.useEffect(() => {
    const getProfile = async () => {
      const userId = localStorage.getItem("userId");
      const res = await axios.get(`${apiurl}/user/profile/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(
        setProfile({
          birthdate: new Date(res.data.profile.birthdate),
          ...res.data.profile,
          ...res.data.user,
        })
      );
    };

    getProfile();
  }, [user.id]);
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 3, "2xl": 6 }}
        gap="20px"
        mb="20px"
      >
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={<FaUserTie size={32} color={brandColor} />}
            />
          }
          name="Nombre des formateurs"
          value={formateurCount}
        />
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg="linear-gradient(90deg, #4481EB 0%, #04BEFE 100%)"
              icon={<FaUser size={32} color={brandColor} />}
            />
          }
          name="Nombre des membres TT"
          value={membrettCount}
        />
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={<FaUser size={32} color={brandColor} />}
            />
          }
          name="Nombre des condidats"
          value={dailyUserCreationData.reduce(
            (total, data) => total + data.count,
            0
          )}
        />

        <MiniStatistics
          endContent={
            <Flex me="-16px" mt="10px">
              <FormLabel htmlFor="balance">
                <Avatar src={Tn} />
              </FormLabel>
            </Flex>
          }
          name="Profit"
          value={totalProfit !== null ? `${totalProfit} DT` : "Loading..."}
        />

        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon w="32px" h="32px" as={MdFileCopy} color={brandColor} />
              }
            />
          }
          name="Totale des formations"
          value={count !== null ? `${count} ` : "Loading..."}
        />
      </SimpleGrid>
      <TotalSpent />
      <SimpleGrid
        columns={{ base: 1, md: 2, xl: 2 }}
        gap="20px"
        mb="20px"
      ></SimpleGrid>
      <SimpleGrid columns={{ base: 1, md: 1, xl: 2 }} gap="20px" mb="20px">
        {/*<CheckTable tableData={tableDataCheck} />*/}
        {/*<FormationsTable loading={loadingFormation} tableData={useTableDataComplex()} />*/}
        <SimpleGrid columns={{ base: 1, md: 2, xl: 2 }} gap="20px">
          <PieCard />
          <MiniCalendar h="100%" minW="100%" selectRange={false} />
        </SimpleGrid>
        <ComplexTable tableData={tableDataComplex1} />
      </SimpleGrid>
      <SimpleGrid columns={{ base: 1, md: 1, xl: 2 }} gap="20px" mb="20px">
        <SimpleGrid columns={{ base: 1, md: 2, xl: 2 }} gap="20px"></SimpleGrid>
      </SimpleGrid>
    </Box>
  );
}
